(function($, undefined) {
	'use strict';
	var prefetched = [];
	var prefetchTimer = null;
	const localStorageKey = 'siteTransition';

	var init = function() {
		if ($('.page-transition_pending').length > 0) {
			$('body').addClass('no-scroll');
			animateTransitionIn();
		}

		if ($('body').hasClass('transition-out')) {
			preFetch();

			$('body').on('click', 'a', (e) => {
				var	href = e.currentTarget.href || e.currentTarget.children[0].href;
				var isTargetBlank = e.currentTarget.target == '_blank' || e.ctrlKey;
				if (href && href.indexOf('javascript') === -1 && href.indexOf('action/') === -1 && !isTargetBlank) {
					transitionToNextPage(e);
				}
			});
		}

	};

	// function preFetchImage(url, callback) {
	// 	var img = new Image();
	// 	img.onload = () => {
	// 		callback(url);
	// 	};
	// 	img.src = url;
	// }

	function preFetch() {
		$('body')
			.on('mouseover', 'a', (e) => {
				if (!e.target.attributes.href || e.target.attributes.href.nodeValue.indexOf('javascript') !== -1 || e.target.attributes.href.nodeValue.indexOf('action/') !== -1) {
					return;
				}
				if (
					e.target.attributes.rel &&
					e.target.attributes.rel.value === 'nofollow'
				) {
					return;
				}
				var value = e.target.href;
				// if (value.indexOf('/') === 0) {
					if (prefetched.indexOf(value) === -1) {
						if (prefetchTimer) {
							clearTimeout(prefetchTimer);
						}
						// console.log(value)
						prefetchTimer = setTimeout(() => {
							$.get(value).done((response) => {
								// console.log(response)
								// var imageRegex = /<img.*?src="([^">]*\/([^">]*?))".*?>/g;
								// var match;
								// while ((match = imageRegex.exec(response))) {
								// 	console.log('test')
								// 	var url = match[1];
								// 	console.log(url)
								// 	if (prefetched.indexOf(url) === -1 && prefetched.length < 5) {
								// 		if (url.indexOf('cdn-2916.kxcdn.com') > -1) {
								// 			// Add it immediately, instead of waiting for the
								// 			// async loading.
								// 			prefetched.push(url);
								// 			preFetchImage(url, (url) => {
								// 				// Nothing to do at the moment.
								// 			});
								// 		}
								// 	}
								// }
							});
							prefetched.push(value);
						}, 200);
					}
				// }
			})
			.on('mouseout', 'a', () => {
				if (prefetchTimer) {
					clearTimeout(prefetchTimer);
				}
			});
	}

	function animateTransitionOut() {
		$('.page-transition').removeClass('page-transition_in page-transition_pending').addClass('page-transition_out');
	}
	
	function animateTransitionIn() {
		$('.page-transition').addClass('page-transition_in').removeClass('page-transition_pending page-transition_out');
		
		setTimeout(() => {
			$('.page-transition').removeClass('page-transition_in');
			$('.page-transition_temp').remove();
			$('body').removeClass('no-scroll');
		}, 1000);
	}
	
	function transitionToNextPage(e) {
		e.preventDefault();
		const currentLocation = window.location.href;
		const {currentTarget} = e;
		const {style:{backgroundImage}} = currentTarget;
		// console.log(e);
		
		const href = currentTarget.href || currentTarget.children[0].href;
		const logo = $('.page-transition__image').attr('src');
		const time = new Date();
		const data = {
			logo,
			time
		}
		animateTransitionOut();
		if(currentLocation === href) {
			setTimeout(() => {
				animateTransitionIn();
			}, 1250);
		} else {
			localStorage.setItem(localStorageKey, JSON.stringify(data));
			setTimeout(() => {
				window.location = href;
			}, 500);
		}
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);